<div class="layout-topbar">

  <!-- <a class="layout-right-panel-button layout-topbar-icon" (click)="appMain.onRightMenuClick($event)" href="#">
      <i class="pi pi-ellipsis-v"></i>
  </a> -->

  <a href="#"
     class="layout-menu-button layout-topbar-icon"
     (click)="appMain.onMenuButtonClick($event)">
    <i class="pi pi-bars"></i>
  </a>
  <a routerLink="/"
     class="layout-topbar-logo">
    <div class="relative">
      <img id="topbar-logo"
           [src]="darkMode ? 'assets/layout/images/humensis_logo_darkmod.png' : 'assets/layout/images/humensis_logo.jpg'"
           height="45">
      <div *ngIf="env !== 'prod'"
           class="absolute top-0 right-0 border-1 border-round font-bold text-xs text-green-500"
           style="padding: 1px 2px;">
        {{ env }}
      </div>
    </div>
  </a>
  <span class="degraded-badge" *ngIf="showDegradedModal">
    Mode dégradé actif
  </span>
  <!--
      <span class="layout-topbar-search">
          <i class="pi pi-search"></i>
          <input type="text" placeholder="Enter your search term">
      </span> -->
  <ul class="topbar-menu"
      *ngIf="(userService.getJWTToken() !== null)">
    <li class="user-profile"
        [ngClass]="{'active-topmenuitem fadeInDown': appMain.topbarUserMenuActive}">
      <a href="#"
         (click)="appMain.onTopbarUserMenuButtonClick($event)"
         *ngIf="!app.inlineUser">
        <img src="assets/layout/images/user_avatar.png"
             alt="roma-layout"/>
        <div class="layout-profile-userinfo">
          <span
            class="layout-profile-name">{{ userService.getUserFirstName() }} {{ userService.getUserLastName() }}</span>
        </div>
      </a>
      <ul class="fadeInDown">
        <!-- <li>
            <a href="#">
                <i class="pi pi-fw pi-user"></i>
                <span>Profile</span>
            </a>
        </li>
        <li>
            <a href="#">
                <i class="pi pi-fw pi-cog"></i>
                <span>Settings</span>
            </a>
        </li>
        <li>
            <a href="#">
                <i class="pi pi-fw pi-envelope"></i>
                <span>Messages</span>
            </a>
        </li>
        <li>
            <a href="#">
                <i class="pi pi-fw pi-bell"></i>
                <span>Notifications</span>
            </a>
        </li> -->
        <li class="dark-theme-switch" (click)="$event.stopPropagation()">
          <i class="pi pi-moon"></i>
          <span>Thème sombre</span>
          <p-inputSwitch [ngModel]="darkMode" (onChange)="onDarkModeChange($event)"></p-inputSwitch>
        </li>
        <li>
          <a routerLink="logout">
            <i class="pi pi-fw pi-power-off"></i>
            <span> Se déconnecter</span>
          </a>
        </li>
      </ul>
    </li>
    <!-- <li [ngClass]="{'active-topmenuitem fadeInDown': appMain.topbarNotificationMenuActive}">
        <a href="#" class="layout-topbar-icon" (click)="appMain.onTopbarNotificationMenuButtonClick($event)">
            <i class="topbar-icon pi pi-fw pi-bell"></i>
        </a>
        <ul class="fadeInDown">
            <li role="menuitem">
                <a href="#"><img src="assets/layout/images/avatar-1.png" alt="">
                    <div class="topbar-menu-info">
                        <span class="topbar-menu-name">Bithika Abhedananda</span>
                        <span class="topbar-menu-role">User interface review is done.</span>
                    </div>
                </a>
            </li>
            <li role="menuitem">
                <a href="#"><img src="assets/layout/images/avatar-2.png" alt="">
                    <div class="topbar-menu-info">
                        <span class="topbar-menu-name">Dai Jiang</span>
                        <span class="topbar-menu-role">Uh, we have sort of a problem here.</span>
                    </div>
                </a>
            </li>
            <li role="menuitem">
                <a href="#"><img src="assets/layout/images/avatar-3.png" alt="">
                    <div class="topbar-menu-info">
                        <span class="topbar-menu-name">Karlien Nijhuis</span>
                        <span class="topbar-menu-role">You apparently didn’t put the thing</span>
                    </div>
                </a>
            </li>
            <li role="menuitem">
                <a href="#"><img src="assets/layout/images/avatar-4.png" alt="">
                    <div class="topbar-menu-info">
                        <span class="topbar-menu-name">Tom Chun</span>
                        <span class="topbar-menu-role">Please check the files</span>
                    </div>
                </a>
            </li>
            <li role="menuitem">
                <a href="#"><img src="assets/layout/images/avatar-5.png" alt="">
                    <div class="topbar-menu-info">
                        <span class="topbar-menu-name">Maria Trofimova</span>
                        <span class="topbar-menu-role">Meeting reports attached.</span>
                    </div>
                </a>
            </li>
        </ul>
    </li> -->
  </ul>
</div>
<style>
  .dark-theme-switch {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem 1rem;
    cursor: default;
  }

  .degraded-badge {
    background-color: #ff5252;
    color: white;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: bold;
    margin-top: 10px;
    margin-left: 1rem;
    font-size: 20px;
  }
</style>
